const Pill = ({ title, content, width, margin, titleWidth, isInlineBlock }) => {
  return (
    <div
      className={`${isInlineBlock ? 'd-inline-block' : 'd-block'} custom-pill`}
    >
      <div
        style={{
          backgroundColor: 'rgba(255,255,255,0.2)',
          width: width,
          margin: margin,
        }}
      >
        <p
          className="mb-0 p-2 ps-4 pe-4 rounded-pill custom-pill-title text-center bg-custom-color"
          style={{
            color: 'white',
            width: titleWidth,
          }}
        >
          {title}
        </p>
      </div>
      <p className="mb-0 pb-1 p-2 pe-4 ps-4">{content}</p>
    </div>
  );
};

export default Pill;
